import { z } from "zod";
import { EntityLevel, EntityType } from "../../../types/types/entity.types";

export const entityLevelSchema = z.custom<EntityLevel>();
export const entityTypeSchema = z.custom<EntityType>();

export type { EntityLevel, EntityType };
